export default __webpack_public_path__ + "static/Gaggenau-08-Bold-42ce33a0105d201c0b810fa067317f48.ttf";